// Healthcare-provider scope for dashboard COUNTS (Launchpad pipeline, Started / Attended strips).
//
// RULE: exclude ONLY NHS. Private and Other leads are included. NHS leads live on their own NHS
// table, and every lead table already leaves them out, so a dashboard number that includes them
// can never match the table it links to.
//
// Which param works where (verified against production):
//   /leads/, /reports/leads/                       → healthcare_provider__in=PRIVATE,OTHER
//   /lead-treatments-flat/, /reports/lead-treatments/ → lead__healthcare_provider__in=PRIVATE,OTHER
// The flat endpoint SILENTLY IGNORES a bare `healthcare_provider=…` (74 rows with or without it),
// which is why the old `healthcare_provider=PRIVATE` on those URLs never filtered anything.
export const NON_NHS_PROVIDERS = 'PRIVATE,OTHER';
export const LEAD_PROVIDER_PARAM = `healthcare_provider__in=${NON_NHS_PROVIDERS}`;
export const TREATMENT_LEAD_PROVIDER_PARAM = `lead__healthcare_provider__in=${NON_NHS_PROVIDERS}`;
